// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3DCi1","errorLogs":"styles_errorLogs__1tZ3e"};